import './App.css'
import './index.css'

import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { RouterConfig } from './navigation'
import useFindUser from './hooks/useFindUser'
import useSentryUser from './hooks/useSentryUser'
import { UserContext } from './hooks/UserContext'
import { StaleBundleGuard } from './components/StaleBundleGuard'

const queryClient = new QueryClient()

function App() {
  const { user, setUser, isLoading } = useFindUser()
  useSentryUser(user)

  return (
    <QueryClientProvider client={queryClient}>
      {/* <PackingProofVideo /> */}
      <UserContext.Provider value={{ user, setUser, isLoading }}>
        <BrowserRouter>
          {/* Inside the router: it reloads on navigation, so it needs useLocation. */}
          <StaleBundleGuard />
          <RouterConfig />
        </BrowserRouter>
      </UserContext.Provider>
    </QueryClientProvider>
  )
}

export default App
